import React from 'react';
import serviceTerritory from './service_territory.json';
import { FeatureCollection } from 'geojson';
import { MapStyle } from '../../../hooks/useOutagesMap';
import { Layer, Source } from 'react-map-gl';
import mainColors from '../../../themes/main-colors';

export const PGEServiceTerritory = ({
  mapStyle = MapStyle.Standard,
}: { mapStyle?: MapStyle } = {}) => {
  const serviceBoundaryGeoJSON: FeatureCollection = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        geometry: {
          type: 'MultiPolygon',
          coordinates: serviceTerritory.coordinates,
        },
        properties: {
          name: 'PGE Service Territory',
        },
      },
    ],
  };

  return (
    <Source id="my-geojson" type="geojson" data={serviceBoundaryGeoJSON}>
      <Layer
        id="polygon-layer"
        type="line"
        paint={{
          'line-color':
            mapStyle === MapStyle.Standard
              ? mainColors.rhinoBlack
              : mainColors.black,
          'line-width': 2,
          'line-opacity': mapStyle === MapStyle.Standard ? 1 : 0.5,
        }}
      />
    </Source>
  );
};
